import { createScoreService } from "behaviour-analyzer-shared";

export const scoreService = createScoreService(localStorage);
